import isEqual from "lodash/isEqual";

interface Props {
  [key: string]: unknown;
}

export const areEqualProps = (props: Props, newProps: Props): boolean =>
  isEqual(props, newProps);
